import { createSlice } from '@reduxjs/toolkit';

const initialState = {};
export const compensationDetailsSlice = createSlice({
  name: 'compensationDetails',
  initialState,
  reducers: {
    resetcompensationDetailsSlice: (state) => initialState,
    addCompensationDetails: (state, action) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { resetcompensationDetailsSlice, addCompensationDetails } = compensationDetailsSlice.actions;

export default compensationDetailsSlice.reducer;
